//import에 대한 설명은 src/Admin/Login/AdminLogin.js 파일에 자세하게 설명해났습니다. 참고하세요.
import React, {useState, useEffect, useRef} from 'react';
//AdminHeader에 대한 설명은 src/Admin/Main.js 참고
import AdminHeader from '../Section/AdminHeader';
import {
  insert_archive,
  get_archive_one,
  update_archive,
} from "../../Axios";

import * as H from '../../Styles/StyleComponentHan';

import { Editor } from '@tinymce/tinymce-react';

import {
  editor_init_data,
} from "../../Variable";

export function ArchiveManagementAdd() {  
  //파라미터 데이터
  //파라미터 데이터는 ArchiveManagement여기에서
  //체크박스 누르고 수정을 누르면
  //http://localhost:3000/ArchiveManagementAdd?archive_ID=2
  //이런식으로 주소를 이동하는데 여기서 아래와 같이 쓰면
  //archive_ID=2를 쓸 수 있다.
  //즉 archive_ID의 고유값인 2를 쓸 수 있는 것이다.
  const params = new URLSearchParams(window.location.search);
  const archive_ID_param = params.get("archive_ID");

  //useState에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고  
  //입력 데이터
  const [archiveTitle, setArchiveTitle] = useState('');
  const [archiveFile1, setArchiveFile1] = useState('');
  const [archiveFile2, setArchiveFile2] = useState('');
  const [archiveFile3, setArchiveFile3] = useState('');
  const [archiveFile4, setArchiveFile4] = useState('');
  const [archiveFile5, setArchiveFile5] = useState('');
  const [archiveFileText1, setArchiveFileText1] = useState('');
  const [archiveFileText2, setArchiveFileText2] = useState('');
  const [archiveFileText3, setArchiveFileText3] = useState('');
  const [archiveFileText4, setArchiveFileText4] = useState('');
  const [archiveFileText5, setArchiveFileText5] = useState('');
  const [archiveStatus, setArchiveStatus] = useState('');

  //에러 출력 데이터
  const [archiveTitleError, setArchiveTitleError] = useState('');

  const editorRef = useRef(null);

  const [htmlString, setHtmlString] = useState("");
  const [initialValue, setInitialValue] = useState("");

  //컨트롤 함수
  const archive_check = () =>{
    let continue_add = true;
    //여기는 등록버튼을 눌렀을 시 값을 안넣으면 에러데이터를 뿌려주는 곳입니다.
    //그리고 에러가 발생되면 위에 continue_add를 false로 바꿔서
    if(archiveTitle === ''){setArchiveTitleError('자료실 타이틀을 등록해 주세요.'); continue_add = false;}else{setArchiveTitleError('');}
    //아래 false일 경우에는 등록하지 않습니다.
    if(continue_add){
      //파라미터가 있으면 저장하고
      if(archive_ID_param === null){
        insert_archive(
          archiveTitle,
          archiveFile1,
          archiveFile2,
          archiveFile3,
          archiveFile4,
          archiveFile5,
          archiveFileText1,
          archiveFileText2,
          archiveFileText3,
          archiveFileText4,
          archiveFileText5,
          htmlString.replace( /'/gi, '"')
        ).then(()=>{
          alert('등록이 완료되었습니다.');
          window.location.href = "/ArchiveManagement";
        });
      }else{
        //파라미터가 없으면 업데이트 한다.
        update_archive(
          archive_ID_param,
          archiveTitle,
          archiveFile1,
          archiveFile2,
          archiveFile3,
          archiveFile4,
          archiveFile5,
          archiveFileText1,
          archiveFileText2,
          archiveFileText3,
          archiveFileText4,
          archiveFileText5,
          archiveStatus,
          htmlString.replace( /'/gi, '"')
        ).then(()=>{
          alert('수정이 완료되었습니다.');
          window.location.href = "/ArchiveManagement";
        });
      }
    }else{
      alert('필수 입력값을 확인해주세요.');
    }
  }

  const file_size_check = (e) => {
    if(e.target.files[0] !== undefined){
      var fsize = e.target.files[0].size;
      var file = Math.round((fsize / 1024));
      if (file >= 10240) {
        return false
      } else {
        return true
      }
    }

}

  // useEffect는 React에서 제공하는 hook인데 자세한 설명은 /src/Admin/Section/AdminHeader.js파일에 설명을 해났음
  useEffect(() => {
    //만약에 파라미터를 보내지 않으면 archive_ID값은 null(빈값으로 오기 떄문에)
    //아래 if조건문에서 null이 아니라면 데이터를 가져올 것이다.
    if(archive_ID_param !== null){
      //특정 ID의 자료실 데이터를 가져오기 위한 함수
      get_archive_one(archive_ID_param).then((result) => {
        //데이터를 가져오면 데이터를 집어넣어준다.
        setArchiveTitle(result[0].archive_title);
        setInitialValue(result[0].archive_content);
        setArchiveStatus(result[0].archive_status);
        setArchiveFileText1(result[0].archive_file_text_1);
        setArchiveFileText2(result[0].archive_file_text_2);
        setArchiveFileText3(result[0].archive_file_text_3);
        setArchiveFileText4(result[0].archive_file_text_4);
        setArchiveFileText5(result[0].archive_file_text_5);

      })
    }
  },[archive_ID_param]);

  return (
    <H.admin_MainWrap> 
      <AdminHeader/>
      <H.admin_rightWrap>
        <H.admin_rightTitBox>
          <H.admin_rightTitInner>
            <p>게시판 관리 - 자료실 관리 {archive_ID_param === null ? ' 등록 ' : ' 수정 '}</p>
            <div> {/* 여기 버튼 클래스 다른거 해뒀는데 일단 기본 "등록"으로 해둘것 */}
              <H.admin_addBtn
                //onClick event에 대한 내용은 src/Admin/Login.js 참고
                onClick={()=>{
                  archive_check();
                }}
              >
                {/* 자료실 파라미터가 있는지 없는지에 따라 등록인지 수정인지 판단 */}
                {archive_ID_param === null ? ' 등록 ' : ' 수정 '}
              </H.admin_addBtn>
            </div>
          </H.admin_rightTitInner>
        </H.admin_rightTitBox>
      
        <H.admin_rightInfoBox>
          <H.admin_rightInfoInner>
            <H.admin_labelBox>
              {/* htmlFor에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고*/}
              <label htmlFor='archive_title'>자료실 타이틀<span> * </span></label>
              <input 
                type='text' 
                id = 'archive_title' 
                maxLength={100} 
                //onChange에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고
                onChange={(event_data)=>{
                  setArchiveTitle(event_data.target.value);
                }} 
                placeholder = "자료실 타이틀을 입력해 주세요."
                value={archiveTitle}
              />
              <H.admin_errorBox className="marginLeft150">{archiveTitleError}</H.admin_errorBox>
            </H.admin_labelBox>

            <H.admin_labelImg>
              <p className="labelImgTit">자료실 파일</p>
              {/* htmlFor에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고*/}
              <div>
                <div className="labelImgFirst">
                  <div className="labelImgSecond">
                      <p>자료실 파일1</p>
                      {/* htmlFor에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고*/}
                      <label htmlFor='archive_file_1'>
                        {/* 자료실 파라미터가 있는지 없는지에 따라 추가인지 변경인지 판단 */}
                        변경
                      </label>
                      <label onClick={()=>{setArchiveFileText1('')}}>
                        삭제
                      </label>
                    </div>
                    <input 
                      className='display_none'
                      type='file' 
                      id='archive_file_1'
                      //이건 input type='file'일 경우만 가능한건데
                      //accept해서 image의 gif, jpeg, png 확장자만 받겠다는 뜻입니다.                             
                      //onChange에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고
                      onChange={(e)=>{
                        if(file_size_check(e)){
                          setArchiveFile1(e.target.files[0]);
                          setArchiveFileText1(e.target.files[0].name);
                        }
                      }}
                    />
                    <p>{archiveFileText1}</p>
                </div>
              </div>
              <div>
                <div className="labelImgFirst">
                  <div className="labelImgSecond">
                      <p>자료실 파일2</p>
                      {/* htmlFor에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고*/}
                      <label htmlFor='archive_file_2'>
                        {/* 자료실 파라미터가 있는지 없는지에 따라 추가인지 변경인지 판단 */}
                        변경
                      </label>
                      <label onClick={()=>{setArchiveFileText2('')}}>
                        삭제
                      </label>
                    </div>
                    <input 
                      className='display_none'
                      type='file' 
                      id='archive_file_2'
                      //이건 input type='file'일 경우만 가능한건데
                      //accept해서 image의 gif, jpeg, png 확장자만 받겠다는 뜻입니다.                             
                      //onChange에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고
                      onChange={(e)=>{
                        if(file_size_check(e)){
                          setArchiveFile2(e.target.files[0]);
                          setArchiveFileText2(e.target.files[0].name);
                        }
                      }}
                    />
                    <p>{archiveFileText2}</p>
                </div>
              </div>
              <div>
                <div className="labelImgFirst">
                  <div className="labelImgSecond">
                      <p>자료실 파일3</p>
                      {/* htmlFor에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고*/}
                      <label htmlFor='archive_file_3'>
                        {/* 자료실 파라미터가 있는지 없는지에 따라 추가인지 변경인지 판단 */}
                        변경
                      </label>
                      <label onClick={()=>{setArchiveFileText3('')}}>
                        삭제
                      </label>
                    </div>
                    <input 
                      className='display_none'
                      type='file' 
                      id='archive_file_3'
                      //이건 input type='file'일 경우만 가능한건데
                      //accept해서 image의 gif, jpeg, png 확장자만 받겠다는 뜻입니다.                             
                      //onChange에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고
                      onChange={(e)=>{
                        if(file_size_check(e)){
                          setArchiveFile3(e.target.files[0]);
                          setArchiveFileText3(e.target.files[0].name);
                        }
                      }}
                    />
                    <p>{archiveFileText3}</p>
                </div>
              </div>
              <div>
                <div className="labelImgFirst">
                  <div className="labelImgSecond">
                      <p>자료실 파일4</p>
                      {/* htmlFor에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고*/}
                      <label htmlFor='archive_file_4'>
                        {/* 자료실 파라미터가 있는지 없는지에 따라 추가인지 변경인지 판단 */}
                        변경
                      </label>
                      <label onClick={()=>{setArchiveFileText4('')}}>
                        삭제
                      </label>
                    </div>
                    <input 
                      className='display_none'
                      type='file' 
                      id='archive_file_4'
                      //이건 input type='file'일 경우만 가능한건데
                      //accept해서 image의 gif, jpeg, png 확장자만 받겠다는 뜻입니다.                             
                      //onChange에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고
                      onChange={(e)=>{
                        if(file_size_check(e)){
                          setArchiveFile4(e.target.files[0]);
                          setArchiveFileText4(e.target.files[0].name);
                        }
                      }}
                    />
                    <p>{archiveFileText4}</p>
                </div>
              </div>
              <div>
                <div className="labelImgFirst">
                  <div className="labelImgSecond">
                      <p>자료실 파일5</p>
                      {/* htmlFor에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고*/}
                      <label htmlFor='archive_file_5'>
                        {/* 자료실 파라미터가 있는지 없는지에 따라 추가인지 변경인지 판단 */}
                        변경
                      </label>
                      <label onClick={()=>{setArchiveFileText5('')}}>
                        삭제
                      </label>
                    </div>
                    <input 
                      className='display_none'
                      type='file' 
                      id='archive_file_5'
                      //이건 input type='file'일 경우만 가능한건데
                      //accept해서 image의 gif, jpeg, png 확장자만 받겠다는 뜻입니다.                             
                      //onChange에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고
                      onChange={(e)=>{
                        if(file_size_check(e)){
                          setArchiveFile5(e.target.files[0]);
                          setArchiveFileText5(e.target.files[0].name);
                        }
                      }}
                    />
                    <p>{archiveFileText5}</p>
                </div>
              </div>
            </H.admin_labelImg>

            {archive_ID_param !== null &&  
            <H.admin_labelBox>
              {/* htmlFor에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고*/}
              <label htmlFor='archive_status'>사용 여부</label>
              <select
                value={archiveStatus}
                //onChange에 대한 내용은 src/Admin/Login/AdminLogin.js 파일 참고
                onChange={(event_data)=>{
                  setArchiveStatus(event_data.target.value);
                }}
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
              
            </H.admin_labelBox>
            }


            <H.listInfoText className="marginTop50">
              <label htmlFor='news_event_editor' className="listInfoTextBold">
                자료실 세부내용 사용 방법 안내<span> * </span>
              </label>
              <p>1. 보안 관계로 ''(작은따옴표)는 사용할 수 없습니다.</p>
              <p>2. ''(작은따옴표)를 사용한 경우에는 자동으로 ""(큰따옴표)로 변경됩니다.</p>
              <p>3. 이미지 파일명은 반드시 영문명으로 지정해야 오류가 나지 않습니다.</p>
              <p>4. 서식 적용이 되지 않을 경우 "서식 - 서식지우기" 아이콘을 활용하여 서식을 초기화 한 후 작성해주세요.</p>
              <p>5. 이미지 등록 시 PC는 최대 가로길이 1200px로 맞춰야 이미지 잘림 없이 볼 수 있습니다.</p>
            </H.listInfoText>
            <H.admin_editorBoxTit>
              자료실 내용
            </H.admin_editorBoxTit>
            <Editor
              //tiny를 쓰기위한 고유 apiKey 전송
              apiKey='kzj2jdtduql44vtgurqnrj4otlx3bkvkiznzk18tvm41yrcj'
              //처음 실행 시 위 선언했던 useRef를 참고함
              onInit={(evt, editor) => editorRef.current = editor}
              //초기 HTML 적용
              initialValue={initialValue}
              //init은 Varibale.js에서 가져왔으며 폰트추가나 플러그인 툴바 등등 에디터에 관한
              //내용을 추가 시키고 있으면 저기서 추가하면 됨
              init={editor_init_data}
              onEditorChange={(newValue, editor) => {
                setHtmlString(newValue);
              }}
            />
          </H.admin_rightInfoInner>
        </H.admin_rightInfoBox>
      </H.admin_rightWrap>
    </H.admin_MainWrap> 
  );
}

//export default에 대한 내용은 src/Admin/Section/AdminHeader.js에 설명해났습니다.
export default ArchiveManagementAdd;
